import React,{useEffect, useState} from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TeamMember = () => {

const [teamMembers, setTeamMembers] = useState([]);
const [activeIndex, setActiveIndex] = useState(null);

const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 700,
    autoplaySpeed: 7000,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    prevArrow: <i className="fa-solid fa-arrow-left"></i>,
    nextArrow: <i className="fa-solid fa-arrow-right"></i>,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
};

  useEffect(()=> {
    const fetchTeamData = async() => {
      try {
        const response = await fetch("/api/frontend/get-all-team");
        const data = await response.json();
        console.log(data);
        setTeamMembers(data);
      } catch (error) {
        console.log("An error occurred:", error);
      }
    }
    fetchTeamData();
  },[]);

  const handleExpendText = (id) => {
    setActiveIndex(activeIndex === id ? null : id);
};


  return (
    <div className="section slider-sec">
    <h1>TEAM</h1>
    <Slider {...sliderSettings} className='team-slider'>
      {
        teamMembers.map((member) => {
          const { id, name, image, designation, content } = member;
          return (
            <div className='team' key={id}>
              <div className="image">
                <div className="img">
                  <img src={`https://madhyadesign.com/api/upload/${image}`} alt='no-img' className='img-fluid' />
                  <div className="info">
                    <h4>{name}</h4>
                    <p className='text-center'>{designation}</p>
                  </div>
                </div>
                <p className="desc">
                  {activeIndex === id ? content : content?.split(' ').slice(0, 3).join(' ')}
                  <a href="#" style={{ textDecoration: "none" }} onClick={() => handleExpendText(id)}>
                    {activeIndex === id ? " Read Less" : "...Read More"}
                  </a>
                </p>
                <div className="social-icons">
                  <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                  <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                  <a href="#"><i className="fa-brands fa-instagram"></i></a>
                </div>
              </div>
            </div>
          );
        })
      }
    </Slider>
  </div>
  )
}

export default TeamMember